$(document).ready(function () {


//ART GALERY FUNCTION START

/* ---------- Open gallery ---------- */
document.getElementById("chooseArtBtn").addEventListener("click", function() {
    document.getElementById("artGalleryModal").classList.add("active");
    loadCategories();
});

/* ---------- Close gallery ---------- */
document.querySelector(".closeArtGallery").addEventListener("click", function () {
    document.getElementById("artGalleryModal").classList.remove("active");
});

/* ---------- Load categories ---------- */
function loadCategories() {
    fetch('https://app.snappytack.com/api/get-categories.php')
        .then(res => res.json())
        .then(data => {
            const list = document.getElementById("art-category-list");
            list.innerHTML = "";
            if (!Array.isArray(data)) return;

            data.forEach((cat, index) => {
                const btn = document.createElement("button");
                btn.className = 'art-cat-btn';
                btn.textContent = cat.name;
                btn.dataset.id = cat.id;

                btn.addEventListener('click', function() {
                    document.querySelectorAll("#art-category-list button").forEach(b => b.classList.remove("active"));
                    btn.classList.add("active");
                    loadImages(cat.id);
                });

                list.appendChild(btn);

                // Auto-click first category
                if (index === 0) btn.click();
            });
        })
        .catch(err => {
            console.error('Failed to load categories', err);
        });
}

/* ---------- Load images for a category ---------- */
function loadImages(categoryId) {
    fetch('https://app.snappytack.com/api/get-images.php?category=' + encodeURIComponent(categoryId))
        .then(res => res.json())
        .then(images => {
            const grid = document.getElementById("art-images-grid");
            grid.innerHTML = "";
            if (!Array.isArray(images) || images.length === 0) {
                grid.innerHTML = '<p class="text-muted">No images in this category.</p>';
                return;
            }

            images.forEach(img => {
                const wrapper = document.createElement('div');
                wrapper.className = 'art-grid-item';

                const el = document.createElement("img");

                // ALWAYS use full path
                const fullURL = "https://app.snappytack.com/" + img.file_path.replace(/^\/+/, "");

                el.src = fullURL;
                el.alt = img.file_name || '';

                el.addEventListener('click', function() {
                    applyArtImage(fullURL);
                });

                wrapper.appendChild(el);
                grid.appendChild(wrapper);
            });
        })
        .catch(err => {
            console.error('Failed to load images', err);
        });
}


/* ---------- Apply the selected art to preview ---------- */
function applyArtImage(imageUrl) {
    const preview = document.querySelector(".preview-img");
    if (!preview) return;

    // Build absolute URL (same as upload)
    const fullURL = imageUrl.startsWith("http")
    ? imageUrl
    : "https://app.snappytack.com/" + imageUrl.replace(/^\/+/, "");

if (fullURL.includes("app.snappytack.com/snappytack.com")) {
    return fullURL.replace("app.snappytack.com/", "");
}

    // Apply selected art image
    preview.src = fullURL;
    preview.classList.remove("default_vectorImg");
    preview.classList.add("uploaded-cstm-img");

    $("#wc-change").hide();
    $("#chooseArtBtn").hide();

    // Make text container switch to update mode
    if ($(".FramedTile .text-container").hasClass("reset_text-container")) {
        $(".FramedTile .text-container")
            .removeClass("reset_text-container")
            .addClass("update_text-container");
    }

    // Apply all the same UI behavior as image upload
    $(".wc-sidebar").addClass("image-uploaded-now");
    $(".wc-toolbar").addClass("active_toolbar");
    $(".TileFrameContent").addClass("block-icon");
    $(".view_wallBtn").addClass("enable-button");
    $(".filter-btn-wrp").removeClass("hidden_filter");

    dragEnabled = true;

    // ↓↓↓ EXACT SAME AUTO-SELECTION LOGIC ↓↓↓

    // First frame size
    var $firstSize = $("#wc-sizes .sc-yuoxai-6").first();
    if ($firstSize.length) {
        var dims = $firstSize.attr("data-testid").split("x");
        $(".Tile").css({
            width: dims[0] + "rem",
            height: dims[1] + "rem"
        });

        $("#wc-sizes .sc-yuoxai-6").removeClass("gkbDRf").addClass("loLSrX");
        $firstSize.removeClass("loLSrX").addClass("gkbDRf");
    }

    // First product type
    var $firstFrame = $("#wc-product-types .sc-yuoxai-6").first();
    if ($firstFrame.length) $firstFrame.click();

    // First size
    var $firstSize = $("#wc-sizes .sc-yuoxai-6").first();
    if ($firstSize.length) $firstSize.click();

    // First frame color
    var $firstColor = $("#wc-frame-colors .sc-yuoxai-6").first();
    if ($firstColor.length) $firstColor.click();

    // First border width
    var $firstBorderWidth = $("#wc-border-width .sc-yuoxai-6").first();
    if ($firstBorderWidth.length) $firstBorderWidth.click();

    // First border color
    var $firstBorderColor = $("#wc-border-colors .sc-yuoxai-6").first();
    if ($firstBorderColor.length) $firstBorderColor.click();

    // Apply fit
    adjustImageFit();

    // Close modal
    document.getElementById("artGalleryModal").classList.remove("active");
}





//ART GALERY FUNCTION END

    // ------------------ Accordion / Steps ------------------
    var $steps = $(".wc-step");
    var $stepHeads = $(".wc-step-head");
    var $stepIndicators = $(".wc-step-indicator");
    
    var dragEnabled = true; // global toggle


    // ------------------ Accordion / Steps (REPLACEMENT) ------------------
    (function () {
    // remove any old handlers to avoid duplicates
    $(".wc-step-head, .wc-step-indicator, .next_grid").off("click");

    function getVisibleSets() {
        var $visibleSteps = $(".wc-step").filter(":visible");
        var $visibleIndicators = $(".wc-step-indicator").filter(":visible");
        var $visibleHeads = $visibleSteps.find(".wc-step-head");
        return { $visibleSteps, $visibleIndicators, $visibleHeads };
    }

    function openStep(index) {
        var sets = getVisibleSets();
        var $visibleSteps = sets.$visibleSteps;
        var $visibleIndicators = sets.$visibleIndicators;

        $visibleSteps.removeClass("active");
        $visibleIndicators.removeClass("active");

        var $targetStep = $visibleSteps.eq(index);
        var $targetIndicator = $visibleIndicators.eq(index);

        if ($targetStep.length) $targetStep.addClass("active");
        if ($targetIndicator.length) $targetIndicator.addClass("active");
    }

    function bindStepHandlers() {
        var sets = getVisibleSets();
        var $visibleSteps = sets.$visibleSteps;
        var $visibleIndicators = sets.$visibleIndicators;
        var $visibleHeads = sets.$visibleHeads;

        // unbind previous listeners on the visible elements (safe)
        $visibleHeads.off("click");
        $visibleIndicators.off("click");
        $(".next_grid").off("click");

        // header click (toggle / open)
        $visibleHeads.each(function (idx) {
        $(this).on("click", function (e) {
            e.preventDefault();
            if ($visibleSteps.eq(idx).hasClass("active")) {
            $visibleSteps.eq(idx).removeClass("active");
            $visibleIndicators.eq(idx).removeClass("active");
            } else {
            openStep(idx);
            }
        });
        });

        // sidebar indicator click
        $visibleIndicators.each(function (idx) {
        $(this).on("click", function (e) {
            e.preventDefault();
            openStep(idx);
        });
        });

        // Next button: calculate position within visible steps
        $(".next_grid").each(function () {
        $(this).on("click", function (e) {
            e.preventDefault();
            var $currentStep = $(this).closest(".wc-step");
            var currentIndex = $visibleSteps.index($currentStep);

            // fallback: if this step is not in visible list, use active visible step
            if (currentIndex === -1) {
            currentIndex = $visibleSteps.index($visibleSteps.filter(".active").first());
            }

            if (currentIndex < $visibleSteps.length - 1) {
            openStep(currentIndex + 1);
            }
        });
        });
    }

    function renumberSteps() {
        var sets = getVisibleSets();
        var $visibleSteps = sets.$visibleSteps;
        var $visibleIndicators = sets.$visibleIndicators;

        $visibleSteps.each(function (idx) {
        var stepNum = idx + 1;

        // Update header number (desktop)
        var $desktopSpan = $(this).find(".headeInner.desktop span").first();
        if ($desktopSpan.length) $desktopSpan.text(stepNum);

        // If mobile header contains a numeric span, update it too (safe guard)
        var $mobileSpan = $(this).find(".headeInner.mobile span").first();
        if ($mobileSpan.length && /^\d+$/.test($mobileSpan.text())) {
            $mobileSpan.text(stepNum);
        }

        // Update the indicator number + data-step
        var $ind = $visibleIndicators.eq(idx);
        if ($ind.length) {
            $ind.find("span").text(stepNum);
            $ind.attr("data-step", idx);
        }
        });

        // Ensure there is a visible active step; if not, activate the first visible step
        if ($visibleSteps.filter(".active").length === 0) {
            if (window.innerWidth >= 990) {
                // Desktop: open the first step by default
                openStep(0);
            } else {
                // Mobile: no step should be active
                $visibleSteps.removeClass("active");
                $visibleIndicators.removeClass("active");
            } 
        } else {
            // Sync indicator active class with active step
            var activeIdx = $visibleSteps.index($visibleSteps.filter(".active").first());
            $visibleIndicators.removeClass("active");
            if (activeIdx >= 0) $visibleIndicators.eq(activeIdx).addClass("active");
        }

        // Re-bind handlers for the current visible set
        bindStepHandlers();
    }

    // Done button: collapse current step
    $(".done_grid").each(function () {
    $(this).on("click", function (e) {
        e.preventDefault();
        var $currentStep = $(this).closest(".wc-step");
        var sets = getVisibleSets();
        var $visibleSteps = sets.$visibleSteps;
        var $visibleIndicators = sets.$visibleIndicators;

        var currentIndex = $visibleSteps.index($currentStep);

        // remove active state from this step + indicator
        $currentStep.removeClass("active");
        if (currentIndex >= 0) {
        $visibleIndicators.eq(currentIndex).removeClass("active");
        }
    });
    });


    // Expose renumberSteps so other code (your product-type click) can call it
    window.renumberSteps = renumberSteps;
    })();



    // ------------------ Load Options ------------------
    function loadOptions() {
        $.getJSON("https://app.snappytack.com/api/get-options.php", function (result) {
            if (result.status !== "success") {
                console.error("API Error:", result);
                return;
            }
            var data = result.data;

            var $tileFrame = $(".Tile3DFrame");
            var $tile = $(".Tile");
            var $tileMatting = $(".TileMatting");
            var $textInput = $("#wc-text");


            // ---------- Product Types ----------
            var $frameWrap = $("#wc-product-types").empty();
            $.each(data.product_types, function (i, frame) {
                var $div = $('<div class="sc-yuoxai-6"></div>')
                    .attr("data-testid", `ctrl-frame-${frame.name.replace(/\s+/g, "-").toLowerCase()}`)
                    .html(`<img src="https://app.snappytack.com/asset/${frame.image}" 
                                    alt="${frame.name}" 
                                    width="30" 
                                    style="vertical-align:middle;margin-right:5px;">
                            <span>${frame.name}</span>`);


            $div.on("click", function () {
                var thickness = parseInt(frame.frame_thickness) || 0;
                var $accordion = $(".wc-step.frame-color-cstm");

                console.log("Accordion found:", $accordion.length, $accordion[0]);
                console.log("Thickness:", thickness);

                // Set frame class
                $tileFrame.attr("class", "Tile3DFrame " + (frame.class_name || ""));

                // Adjust FramedTile size
                $(".FramedTile").css({
                    width: `calc(100% - ${thickness}px)`,
                    height: `calc(100% - ${thickness}px)`
                });

                // Highlight selected product type
                $frameWrap.find(".sc-yuoxai-6").removeClass("active-value");
                $div.addClass("active-value");

                // Add/remove class on parent accordion based on thickness
                if (thickness === 0) {
                    $accordion.addClass("no-frame").hide(); // hide step
                } else {
                    $accordion.removeClass("no-frame").show(); // show step
                }

                // 🔑 Re-number steps after hiding/showing
                renumberSteps();
                resizeImageToContainer();
            });





                $frameWrap.append($div);
            });

            // ---------- Sizes ----------
            var $sizeWrap = $("#wc-sizes").empty();
            $.each(data.sizes, function (i, size) {
                var $div = $('<div class="sc-yuoxai-6"></div>')
                    .attr("data-testid", size.dimensions)
                    .html(`<span>${size.dimensions}</span> <span>£${parseFloat(size.price).toFixed(2)}</span>`);

                $div.on("click", function () {
                    // // Apply Tile size
                    // $(".Tile").css({
                    //     width: size.dimensions.split("x")[0] + "rem",
                    //     height: size.dimensions.split("x")[1] + "rem"
                    // });

                    // Base size
                    var w = parseFloat(size.dimensions.split("x")[0]);
                    var h = parseFloat(size.dimensions.split("x")[1]);

                    // Window width
                    var winW = $(window).width();
                    var scale = 1; // default (100%)

                    if (winW < 361) {
                        scale = 0.55; // 45% smaller
                    } else if (winW < 400) {
                        scale = 0.60; // 40% smaller
                    } else if (winW < 481) {
                        scale = 0.65; // 35% smaller
                    } else if (winW < 576) {
                        scale = 0.70; // 30% smaller
                    } else if (winW < 749) {
                        scale = 0.75; // 25% smaller
                    }

                    // Apply scaled dimensions
                    $(".Tile").css({
                        width: (w * scale) + "rem",
                        height: (h * scale) + "rem"
                    });

                    // Reset and highlight selected
                    $sizeWrap.find(".sc-yuoxai-6").removeClass("active-value");
                    $div.addClass("active-value");

                    // 👉 Update Price
                    $("#wc-price").text("£" + parseFloat(size.price).toFixed(2));
                    //SAVE PRICE
                    $("#wc-price").data("selectedPrice", parseFloat(size.price).toFixed(2));

                    resizeImageToContainer();
                    resetTextPosition();
                });

                $sizeWrap.append($div);
            });




            // ---------- Frame Colors ----------
            var $frameColorWrap = $("#wc-frame-colors").empty();

            $.each(data.frame_colors, function (i, color) {
                var $div = $('<div class="sc-yuoxai-6"></div>')
                    .attr("data-testid", color.name.toLowerCase())
                    .html(`<div style="border-color:${color.hex};"></div>
                        <span>${color.name}</span>`);

                $div.on("click", function () {
                    // Set frame color on Tile
                    $(".Tile").css("background", color.hex);

                    // Mark selected color as active
                    $frameColorWrap.find(".sc-yuoxai-6").removeClass("active-value");
                    $div.addClass("active-value");
                });

                $frameColorWrap.append($div);
            });

            // ---------- Borders ----------
            var $borderWidthWrap = $("#wc-border-width").empty();
            var $borderColorWrap = $("#wc-border-colors").empty();

            $.each(data.borders, function (i, border) {
                // ---------- Border Width ----------
                var $widthDiv = $('<div class="sc-yuoxai-6"></div>')
                    .attr("data-testid", border.width)
                    .text(border.width + "cm");

                $widthDiv.on("click", function () {
                    $tileFrame.css({
                        width: `calc(100% - ${border.width}rem)`,
                        height: `calc(100% - ${border.width}rem)`
                    });

                    // Mark selected border width as active
                    $borderWidthWrap.find(".sc-yuoxai-6").removeClass("active-value");
                    $widthDiv.addClass("active-value");

                    // var stepIndex = $widthDiv.closest(".wc-step").index(".wc-step");
                    // if ($steps.eq(stepIndex + 1).length) openStep(stepIndex + 1);
                });
                $borderWidthWrap.append($widthDiv);

                // ---------- Border Color ----------
                var colorName = border.color_name || border.color; // fallback if color_name missing
                var $colorDiv = $('<div class="sc-yuoxai-6"></div>')
                    .attr("data-testid", colorName.toLowerCase())
                    .html(`<div style="background:${border.color}; width:20px; height:20px; border:1px solid #000; display:inline-block; margin-right:5px;"></div>
                        <span>${colorName}</span>`);

                $colorDiv.on("click", function () {
                    $tileFrame.css("border-width", $borderWidthWrap.find(".active-value").text()); // optional if you want width updated
                    $(".FramedTile").css("background", border.color);

                    // Mark selected border color as active
                    $borderColorWrap.find(".sc-yuoxai-6").removeClass("active-value");
                    $colorDiv.addClass("active-value");
                });

                $borderColorWrap.append($colorDiv);
            });


            // ---------- Fonts ----------
            // ---------- Fonts ----------
            var $fontWrap = $("#wc-fonts").empty();
            $.each(data.fonts, function (i, font) {
                if (font.file) {
                    // Inject @font-face dynamically
                    var style = document.createElement("style");
                    var ext = font.file.split(".").pop().toLowerCase();
                    var format = (ext === "woff" ? "woff" : ext === "woff2" ? "woff2" : "truetype");

                    style.innerHTML = `
                        @font-face {
                            font-family: '${font.name}';
                            src: url('${font.file}') format('${format}');
                            font-display: swap;
                        }
                    `;
                    document.head.appendChild(style);
                }

                // Create preview + store font data
                var $div = $('<div class="sc-yuoxai-6"></div>')
                    .attr("data-testid", font.name.toLowerCase())
                    .html(`
                        <span 
                            style="font-family:'${font.name}';color:${font.color}" 
                            data-font-url="${font.file}" 
                            data-font-name="${font.name}" 
                            data-font-color="${font.color}">
                            ${font.name}
                        </span>
                    `);

                // On click → apply font
                $div.on("click", function () {
                    var $span = $(this).find("span");
                    var fontUrl = $span.data("font-url");
                    var fontName = $span.data("font-name");
                    //var fontColor = $span.data("font-color");

                    // Apply to text fields
                    $textInput.css({ fontFamily: fontName });
                    $(".border-text").css({ fontFamily: fontName });
                    //$(".rotate-handle").css({ color: fontColor });

                    // If needed later, fontUrl is available too
                    console.log("Selected font file:", fontUrl);
                });

                $fontWrap.append($div);
            });



        }).fail(function (err) {
            console.error("Error loading options:", err);
        });
    }

    // ------------------ Image Upload ------------------
    function initImageUpload() {
        var $fileInput = $("#wc-file");
        var $uploadBtn = $("#wc-change");
        var $img = $(".preview-img");

        if (!$img.length) return;

        var originalSrc = $img.attr("src");
        var objectUrl = null;

        $uploadBtn.on("click", function () {
            $fileInput.click();
            // $(this).parent(".tile-image").addClass("actv");

        });

        $fileInput.on("change", function (e) {
            // var file = e.target.files && e.target.files[0];
            // if (!file) return;
            // if (objectUrl) URL.revokeObjectURL(objectUrl);
            // objectUrl = URL.createObjectURL(file);
            // $img.attr("src", objectUrl).addClass("uploaded-cstm-img");
            adjustImageFit();
            $uploadBtn.parent().toggleClass("actv");
            dragEnabled = true;
        });  


        $fileInput.on("change", function (e) {
            var file = e.target.files && e.target.files[0];
            if (!file) return;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
            objectUrl = URL.createObjectURL(file);
            $img.attr("src", objectUrl).removeClass("default_vectorImg");
            $img.attr("src", objectUrl).addClass("uploaded-cstm-img");
            if ($(".FramedTile .text-container").hasClass("reset_text-container")) {
                $(".FramedTile .text-container").removeClass("reset_text-container");
                $(".FramedTile .text-container").addClass("update_text-container");
            };

            // Add class to sidebar after image upload
            $(".wc-sidebar").addClass("image-uploaded-now");
            $(".wc-toolbar").addClass("active_toolbar");
            $(".TileFrameContent").addClass("block-icon");
            $(".view_wallBtn").addClass("enable-button");
            $(".filter-btn-wrp").removeClass("hidden_filter");

            // After upload, set first frame size
            var $firstSize = $("#wc-sizes .sc-yuoxai-6").first();
            if ($firstSize.length) {
                var dims = $firstSize.attr("data-testid").split("x");
                $(".Tile").css({ width: dims[0] + "rem", height: dims[1] + "rem" });
                $("#wc-sizes .sc-yuoxai-6").removeClass("gkbDRf").addClass("loLSrX");
                $firstSize.removeClass("loLSrX").addClass("gkbDRf");
            }

            // After upload, apply first Product Type
            var $firstFrame = $("#wc-product-types .sc-yuoxai-6").first();
            if ($firstFrame.length) $firstFrame.click();

            // Apply first Size
            var $firstSize = $("#wc-sizes .sc-yuoxai-6").first();
            if ($firstSize.length) $firstSize.click();

            // Apply first Frame Color
            var $firstColor = $("#wc-frame-colors .sc-yuoxai-6").first();
            if ($firstColor.length) $firstColor.click();

            //  Apply first Border Width
            var $firstBorderWidth = $("#wc-border-width .sc-yuoxai-6").first();
            if ($firstBorderWidth.length) $firstBorderWidth.click();

            //  Apply first Border Color
            var $firstBorderColor = $("#wc-border-colors .sc-yuoxai-6").first();
            if ($firstBorderColor.length) $firstBorderColor.click();
            adjustImageFit();
        });

    }

//CUSTOM FUNCTION:







// Main uploaded image drag & make a clone for High-res
    var $container = $(".TileImageContainer");
    var $img = $container.find("img.preview-img");

    var isDragging = false;
    var startX = 0, startY = 0;
    var offsetX = 0, offsetY = 0;   // extra pan offsets
    var baseOffsetX = 0, baseOffsetY = 0;
    var currentScale = 1;
    var aspect = 1;

    var naturalWidth = 0, naturalHeight = 0;

    // Ensure image's native dims captured even if already loaded
    function onImageReady() {
        var el = $img[0];
        if (el && el.naturalHeight > 0) {
            naturalWidth = el.naturalWidth;
            naturalHeight = el.naturalHeight;
            aspect = el.naturalWidth / el.naturalHeight;

            // keep a reference to original Image
            sourceImg = new Image();
            sourceImg.src = el.src;
        }
        clampOffsets();
    }
    $img.on("load", onImageReady);
    if ($img[0] && $img[0].complete) setTimeout(onImageReady, 0);

    // Prevent native drag image behavior
    $img.on("dragstart", function (e) { e.preventDefault(); });

    function getRenderedSize() {
        // var cw = $container.width();
        // var ch = $container.height();
        // var baseH = ch;
        // var baseW = ch * aspect;
        // return { cw: cw, ch: ch, w: baseW * currentScale, h: baseH * currentScale };
        var cw = $container.width();
        var ch = $container.height();

        var imgAspect = aspect; // naturalWidth / naturalHeight
        var contAspect = cw / ch;

        let baseW, baseH;

        if (imgAspect > contAspect) {
            // Image is wider → match container height (cover top/bottom)
            baseH = ch;
            baseW = ch * imgAspect;
        } else {
            // Image is taller/narrower → match container width (cover sides)
            baseW = cw;
            baseH = cw / imgAspect;
        }

        return {
            cw: cw,
            ch: ch,
            w: baseW * currentScale,
            h: baseH * currentScale
        };
    }

    function applyTransform() {
        
        const size = getRenderedSize(); // ✅ now defined
        $img.css({
            width: size.w + "px",
            height: size.h + "px",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: `translate(-50%, -50%) translate(${offsetX}px, ${offsetY}px)`,
            "transform-origin": "center center"
        });
    }

    function clampOffsets() {


        // applyTransform();
        var s = getRenderedSize();
        if (!s.cw || !s.ch) return;

        // max drag space allowed (half of extra area)
        var extraX = Math.max(0, (s.w - s.cw) / 2);
        var extraY = Math.max(0, (s.h - s.ch) / 2);

        offsetX = Math.min(extraX, Math.max(-extraX, offsetX));
        offsetY = Math.min(extraY, Math.max(-extraY, offsetY));

        applyTransform();
    }

    // --- Drag handling with pointer events ---
    function startDrag(e) {
        if (!dragEnabled) return;
        if ($(e.target).is("button, input, label")) return;
        e.preventDefault();

        isDragging = true;

        let ev = e.originalEvent || e;
        startX = ev.clientX || (ev.touches && ev.touches[0].clientX) || 0;
        startY = ev.clientY || (ev.touches && ev.touches[0].clientY) || 0;

        baseOffsetX = offsetX;
        baseOffsetY = offsetY;

        $(document)
            .on("pointermove.wcDrag", onMove)
            .on("pointerup.wcDrag pointercancel.wcDrag", endDrag);

        $container.css("cursor", "grabbing");
    }

    function onMove(e) {
        if (!isDragging) return;

        let ev = e.originalEvent || e;
        let clientX = ev.clientX || (ev.touches && ev.touches[0].clientX);
        let clientY = ev.clientY || (ev.touches && ev.touches[0].clientY);
        if (clientX == null || clientY == null) return;

        let dx = clientX - startX;
        let dy = clientY - startY;

        offsetX = baseOffsetX + dx;
        offsetY = baseOffsetY + dy;

        clampOffsets();
    }

    function endDrag() {
        isDragging = false;
        $(document).off(".wcDrag");
        $container.css("cursor", "grab");
    }

    // ✅ Use pointer events (work for mouse + touch)
    $container.on("pointerdown", startDrag);


        // Zoom input
        $("#wc-zoom-range").on("input", function () {
            var zoomValue = +this.value;
            $("#wc-zoom-label").text(zoomValue + "%");
            currentScale = zoomValue / 100;
            clampOffsets();
        });

        // Re-check on resize
        $(window).on("resize", clampOffsets);

        // initial state
        $container.css("cursor", "grab");
        clampOffsets();

        function resizeImageToContainer() {
            clampOffsets();   // makes sure offsets are valid
            applyTransform(); // re-render the image
        }

        
        // ------------------
        // 🔹 EXPORT FUNCTION to a high-res base64 string
        // ------------------
        function exportHighRes() {
            if (!naturalWidth || !naturalHeight) return null;

            var contW = $container.width();
            var contH = $container.height();

            // Optional: upscale for high-res
            var scaleFactor = 2;
            var canvas = document.createElement("canvas");
            canvas.width = contW * scaleFactor;
            canvas.height = contH * scaleFactor;
            var ctx = canvas.getContext("2d");

            // --- Calculate how the image is displayed in the container ---
            var imgAspect = naturalWidth / naturalHeight;
            var contAspect = contW / contH;

            var baseDisplayWidth, baseDisplayHeight;

            if (imgAspect > contAspect) {
                // image is wider → fit height = 100%
                baseDisplayHeight = contH;
                baseDisplayWidth = naturalWidth * (contH / naturalHeight);
            } else {
                // image is taller → fit width = 100%
                baseDisplayWidth = contW;
                baseDisplayHeight = naturalHeight * (contW / naturalWidth);
            }

            // Apply zoom
            var imgDisplayWidth = baseDisplayWidth * currentScale;
            var imgDisplayHeight = baseDisplayHeight * currentScale;

            // Image center in container
            var imgCenterX = contW / 2 + offsetX;
            var imgCenterY = contH / 2 + offsetY;

            // Top-left corner
            var drawX = imgCenterX - imgDisplayWidth / 2;
            var drawY = imgCenterY - imgDisplayHeight / 2;

            // --- Draw into canvas ---
            ctx.drawImage(
                $img[0],
                0, 0, naturalWidth, naturalHeight, // source
                drawX * scaleFactor,
                drawY * scaleFactor,
                imgDisplayWidth * scaleFactor,
                imgDisplayHeight * scaleFactor
            );

            return canvas.toDataURL("image/jpeg", 0.95);
        }
    // 🔹 EXPORT FUNCTION to a high-res base64 string

        // Example: hook to button
        function dataURLtoBlob(dataURL) {
            var parts = dataURL.split(';base64,');
            var contentType = parts[0].split(':')[1];
            var byteCharacters = atob(parts[1]);
            var byteNumbers = new Array(byteCharacters.length);

            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);
            return new Blob([byteArray], { type: contentType });
        }

        $("#export-btn").on("click", function () {
            console.log("✅ Export button clicked");
            var dataUrl = exportHighRes();
            console.log("dataUrl:", dataUrl ? dataUrl.substring(0, 50) : "null");

            if (!dataUrl) {
                alert("exportHighRes() returned null. Maybe image not loaded?");
                return;
            }

            var blob = dataURLtoBlob(dataUrl);
            var blobUrl = URL.createObjectURL(blob);

            var win = window.open("", "_blank");
            if (win) {
                win.document.write(`
                    <html>
                    <head><title>Exported Image</title></head>
                    <body style="margin:0;display:flex;align-items:center;justify-content:center;background:#111;">
                        <img src="${blobUrl}" style="max-width:100%;height:auto;"/>
                    </body>
                    </html>
                `);
                win.document.close();
            } else {
                alert("Popup blocked! Please allow popups for this site.");
            }
        });
    // Main uploaded image drag & make a clone for High-res






    //CUSTOM WIDTH HEIGHT CALCULATE

    function adjustImageFit() {
        var $container = $(".tile-image");
        var $img = $container.find(".preview-img");

        if (!$container.length || !$img.length) {
            console.log("No container or image found");
            return;
        }

        var containerWidth = $container.width();
        var containerHeight = $container.height();

        console.log("Container Size → width:", containerWidth, "height:", containerHeight);

        if (containerWidth < containerHeight) {
            // Taller container → fit by height
            $img.css({
                height: "100%",
                width: "auto"
            });
            console.log("Applied: height=100%, width=auto");
        } else {
            // Wider container → fit by width
            $img.css({
                width: "100%",
                height: "auto"
            });
            console.log("Applied: width=100%, height=auto");
        }
    }

    // Update text on border while typing
    $("#wc-text").on("input", function () {
        $(".border-text").text($(this).val());
    });

    // Update size
    $("#wc-font-size").on("input", function () {
        var val = $(this).val();
        $("#wc-font-size-value").text(val + "px");
        $("#wc-text").css("font-size", val + "px");
        $(".border-text").css("font-size", val + "px");
    });

    // Update color
    $("#wc-font-color").on("input", function () {
        var color = $(this).val();
        $("#wc-text").css("color", color);
        $(".border-text").css("color", color);
    });


    // ---------------- Drag Border Text ----------------
    var $textContainer = $(".text-container");
    var $text = $(".border-text");

    var isDraggingText = false;
    var textStartX = 0, textStartY = 0;
    var textBaseX = 0, textBaseY = 0;

    // --- Start drag ---
    function startTextDrag(e) {
        e.preventDefault();
        isDraggingText = true;

        textStartX = e.clientX;
        textStartY = e.clientY;

        textBaseX = parseFloat($textContainer.css("left")) || 0;
        textBaseY = parseFloat($textContainer.css("top")) || 0;

        $text.css("cursor", "grabbing");

        $(document)
            .on("pointermove.textDrag", onTextMove)
            .on("pointerup.textDrag pointercancel.textDrag", endTextDrag);
    }

    // --- Move drag ---
    function onTextMove(e) {
        if (!isDraggingText) return;

        var dx = e.clientX - textStartX;
        var dy = e.clientY - textStartY;

        var newLeft = textBaseX + dx;
        var newTop = textBaseY + dy;

        var parent = $textContainer.parent();
        var parentRect = parent[0].getBoundingClientRect();

        // Apply temp position to measure
        $textContainer.css({ left: newLeft + "px", top: newTop + "px" });
        var rect = $textContainer[0].getBoundingClientRect();

        // Clamp inside parent
        if (rect.left < parentRect.left) newLeft += parentRect.left - rect.left;
        if (rect.top < parentRect.top) newTop += parentRect.top - rect.top;
        if (rect.right > parentRect.right) newLeft -= rect.right - parentRect.right;
        if (rect.bottom > parentRect.bottom) newTop -= rect.bottom - parentRect.bottom;

        $textContainer.css({ left: newLeft + "px", top: newTop + "px" });
    }

    // --- End drag ---
    function endTextDrag() {
        isDraggingText = false;
        $text.css("cursor", "grab");
        $(document).off(".textDrag");
    }

    // --- Reset text position function ---
    function resetTextPosition() {
        $textContainer.css({
            left: "50%",
            bottom: "0",
            top: "auto", // reset top if was changed during drag
            transform: "translate(-50%, 0)"
        });
    }

    // ✅ Attach with pointer events
    $text.on("pointerdown", startTextDrag);
 



    //VIEW ON WALL START


// Robust preview + Safari fixes + first-click reliability
var $modal = document.querySelector("#wallModal");
var $wallPreview = document.querySelector("#wallPreview");
var imgSrc;
var processingPreview = false;
var lastStage = null;
var btn = document.querySelector('.view_wallBtn');

async function ensureContainerReady(container, maxWait = 3000) {
  if (!container) return;
  // Wait for fonts (if supported)
  if (document.fonts && document.fonts.ready) {
    try {
      await Promise.race([document.fonts.ready, new Promise(r => setTimeout(r, 200))]);
    } catch (e) { /* ignore */ }
  }

  // Wait for all images inside the container to be loaded (or timeout per-image)
  const imgs = Array.from(container.querySelectorAll('img'));
  if (imgs.length) {
    await Promise.all(imgs.map(img => {
      if (img.complete && img.naturalWidth !== 0) return Promise.resolve();
      return new Promise(resolve => {
        let done = () => { if (!done._called) { done._called = true; resolve(); } };
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
        // per-image timeout fallback
        setTimeout(done, Math.min(1200, maxWait));
      });
    }));
  }

  // allow layout/paint to settle
  await new Promise(requestAnimationFrame);
  await new Promise(requestAnimationFrame);
  await new Promise(r => setTimeout(r, 30));
}

function toPngWithTimeout(node, ms = 15000) {
  return Promise.race([
    htmlToImage.toPng(node),
    new Promise((_, rej) => setTimeout(() => rej(new Error('htmlToImage timeout')), ms))
  ]);
}





btn.addEventListener('click', async () => {
  const tile = document.querySelector('.TileImageContainer');
  if (!tile) return;

  // Prevent double clicks / concurrent renders
  if (processingPreview) return;
  processingPreview = true;
  btn.disabled = true;
  tile.style.cursor = 'grabbing';

  setTimeout(async () => {
    tile.style.cursor = '';

    // show modal + loader immediately (good UX for slow browsers)
    $modal.style.display = "block";
    $wallPreview.innerHTML = "<div class='loading-spinner'>Loading preview…</div>";

    const container = document.querySelector('.Tile');

    try {
      // 1) Make sure dynamic content (images/fonts) is settled
      await ensureContainerReady(container, 3000);

      // 2) Render to PNG (with timeout)
      const dataUrl = await toPngWithTimeout(container, 15000);


      

      // 3) Create image and ensure decode (Safari-friendly)
      imgSrc = new Image();
      imgSrc.crossOrigin = "anonymous"; // keep if images are CORS-enabled
      imgSrc.src = dataUrl;

      // double RAF for Safari -> give paint a chance
      await new Promise(requestAnimationFrame);
      await new Promise(requestAnimationFrame);

      try {
        await imgSrc.decode();
      } catch (e) {
        // decode can reject in some browsers; fallback to onload with a short timeout
        await new Promise(res => {
          let called = false;
          imgSrc.onload = () => { if (!called) { called = true; res(); } };
          imgSrc.onerror = () => { if (!called) { called = true; res(); } };
          setTimeout(() => { if (!called) { called = true; res(); } }, 2000);
        });
      }

      // force layout flush
      void imgSrc.offsetHeight;

      // compute scale and style
      const width = imgSrc.naturalWidth || 1000;
      const height = imgSrc.naturalHeight || 600;
      const winW = window.innerWidth;
      let scale = 0.65;
      if (winW < 400) scale = 0.18;
      else if (winW < 576) scale = 0.20;
      else if (winW < 749) scale = 0.25;
      else if (winW < 990) scale = 0.30;
      else if (winW < 1299) scale = 0.35;

      imgSrc.style.width = width * scale + "px";
      imgSrc.style.height = height * scale + "px";
      imgSrc.style.position = "absolute";
      imgSrc.style.top = "50%";
      imgSrc.style.left = "50%";
      imgSrc.style.transform = "translate(-50%, -50%)";
      imgSrc.style.cursor = "grab";
      imgSrc.style.userSelect = "none";
      imgSrc.style.webkitUserDrag = "none";

      // wrap in stage
      const stage = document.createElement('div');
      stage.className = 'preview-stage';
      stage.style.width = "100%";
      stage.style.height = "100%";
      stage.style.position = "relative";
      stage.style.backgroundColor = "transparent";

      stage.appendChild(imgSrc);

      // remove previous stage if any
      if (lastStage && lastStage.parentNode) {
        lastStage.parentNode.removeChild(lastStage);
      }
      lastStage = stage;

      // replace loader with the final preview
      $wallPreview.innerHTML = "";
      $wallPreview.appendChild(stage);

      // attach draggable behavior
      if (typeof makeDraggable === 'function') {
        makeDraggable(imgSrc, $wallPreview);
      }

    } catch (err) {
      console.error("Preview generation failed:", err);
      $wallPreview.innerHTML = "<p style='color:red'>Failed to load preview.</p>";
    } finally {
      processingPreview = false;
      btn.disabled = false;
    }
  }, 500);
});





    //CHANGE WALL IMAGE

    // When "Change Wall Image" is clicked
    document.querySelector("#changeWallImage").addEventListener("click", () => {
        document.querySelector("#wallImageUpload").click();
    });

    // Handle uploaded file
    document.querySelector("#wallImageUpload").addEventListener("change", (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = function (e) {
            // ✅ Set uploaded image as background of .wall-preview
            document.querySelector(".wall-preview").style.backgroundImage = `url(${e.target.result})`;
            document.querySelector(".wall-preview").style.backgroundSize = "cover";
            document.querySelector(".wall-preview").style.backgroundPosition = "center";
            
            console.log("Wall background updated:", file.name);
        };
        reader.readAsDataURL(file);
    }); 


    // Dragging function
    function makeDraggable(img, container) {
        let isDragging = false;
        let startX, startY, initialX, initialY;

        // --- Start drag ---
        img.addEventListener("pointerdown", (e) => {
            e.preventDefault();
            isDragging = true;
            img.style.cursor = "grabbing";

            startX = e.clientX;
            startY = e.clientY;

            const rect = img.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            initialX = rect.left - containerRect.left;
            initialY = rect.top - containerRect.top;

            // cancel transform centering once dragging starts
            img.style.transform = "none";

            // capture moves until pointerup
            window.addEventListener("pointermove", onPointerMove);
            window.addEventListener("pointerup", endDrag);
            window.addEventListener("pointercancel", endDrag);
        });

        function onPointerMove(e) {
            if (!isDragging) return;

            const dx = e.clientX - startX;
            const dy = e.clientY - startY;

            let newX = initialX + dx;
            let newY = initialY + dy;

            const containerRect = container.getBoundingClientRect();
            const imgRect = img.getBoundingClientRect();

            const maxX = containerRect.width - imgRect.width;
            const maxY = containerRect.height - imgRect.height;

            newX = Math.max(0, Math.min(newX, maxX));
            newY = Math.max(0, Math.min(newY, maxY));

            img.style.left = newX + "px";
            img.style.top = newY + "px";
        }

        function endDrag() {
            if (isDragging) {
                isDragging = false;
                img.style.cursor = "grab";

                window.removeEventListener("pointermove", onPointerMove);
                window.removeEventListener("pointerup", endDrag);
                window.removeEventListener("pointercancel", endDrag);
            }
        }
    }



    // Close modal
    document.querySelectorAll(".close-modal, #backToConfig").forEach(function (element) {
        element.addEventListener("click", function () {
            console.log("Modal clicked");
            $modal.style.display = "none"; // assuming $modal is a DOM element
        });
    });

    // Click outside closes
    $(window).on("click", function (e) {
        if (e.target === $modal) {
            $($modal).hide(); // wrap in jQuery to use .hide()
        }
    });

    //create product function

    function createProduct(product) {
        return $.post("/create-product.php", product)
            .done(function (res) {
                console.log("Product created:", res);
            })
            .fail(function (err) {
                console.error("Error creating product:", err);
            });
    }

    //SHOW LIMIT POPUP
    function showErrorPopup(message) {
        $("#popupMessage").text(message);
        $("#errorPopup").fadeIn();
    }

    // close popup
    $("#closePopup").on("click", function () {
        $("#errorPopup").fadeOut();
    });


    $(".wc-btn-cart").on("click", async function () {
        if (!savedProducts.length) {
            alert("No saved products to add to cart");
            return;
        }

        // ✅ validate piece count
        // const pieceCount = savedProducts.length;
        // if (![3, 4, 6].includes(pieceCount)) {
        //     showErrorPopup("Only 3-piece, 4-piece, or 6-piece sets are allowed.");
        //     return;
        // }


        $("#globalLoader").fadeIn(200);

        for (let product of savedProducts) {
            try {
                // Step 1: upload base64 image
                let res = await $.post(
                    "https://app.snappytack.com/api/save-upload.php",
                    { image: product.imageBase64 }
                );
                if (typeof res === 'string') res = JSON.parse(res);
                if (res.status !== "success") throw res.message || "Image upload failed";

                console.log("Uploaded image URL:", res.url);

                // Step 2: create product
                let config = {
                    size: product.size,
                    frame: product.frame,
                    frameColor: product.frameColor,
                    borderWidth: product.borderWidth,
                    borderColor: product.borderColor,
                    text: product.text,
                    font: product.font,
                    image: res.url, // uploaded image URL
                    price: product.price || "99.99"
                };

                let productRes = await $.ajax({
                    url: "https://app.snappytack.com/api/custom-create-product.php",
                    method: "POST",
                    data: JSON.stringify(config),
                    //contentType: "application/json"
                });

                if (productRes.status !== "success") throw productRes.message || "Product creation failed";

                // Step 3: add to Shopify cart
                await $.post("/cart/add.js", {
                    id: productRes.variant_id,
                    quantity: 1,
                    properties: {
                        Size: product.size,
                        Frame: product.frame,
                        "Frame Color": product.frameColor,
                        "Border Width": product.borderWidth,
                        "Border Color": product.borderColor,
                        Text: product.text,
                        Font: product.font
                    }
                });

                console.log("Added to cart:", product);

            } catch (err) {
                console.error("Error processing product:", err);
                $("#globalLoader").fadeOut(200);
            }
        }

        savedProducts = [];
        localStorage.removeItem("savedProducts");

        // Optional: redirect after all added
        window.location.href = "/cart";
    });

    
    //SAVE BUTTON function start
    let savedProducts = JSON.parse(localStorage.getItem("savedProducts") || "[]");
    renderSavedProducts();
    
    $("#saveProductBtn").on("click", async function () {
        $(".saved_productList_wrap").addClass("open");
        $("#savedProductsLoader").show();
    
        const container = document.querySelector('.Tile');
    
        try {
            // ✅ Generate PNG
            let dataUrl = await htmlToImage.toPng(container);
    
            // ✅ Safari fix: force decode + reflow
            const img = new Image();
            await new Promise(requestAnimationFrame); // wait a frame
            img.src = dataUrl;
            await img.decode(); // ensure fully decoded
            void img.offsetHeight; // force Safari reflow
    
            // ✅ If still blank (Safari sometimes), retry once
            if (img.naturalWidth === 0 || img.naturalHeight === 0) {
                console.warn("Safari blank image detected — retrying...");
                dataUrl = await htmlToImage.toPng(container);
                img.src = dataUrl;
                await img.decode();
            }
    
            const base64Data = dataUrl.replace(/^data:image\/png;base64,/, "");
    
            // ✅ Upload snapshot to server
            const res = await $.post(
                "https://app.snappytack.com/api/save-upload.php",
                { image: base64Data }
            );
    
            let parsed = typeof res === "string" ? JSON.parse(res) : res;
            if (parsed.status !== "success") throw parsed.message || "Image upload failed";
    
            // ✅ Build config
            const config = {
                size: $("#wc-sizes .active-value").data("testid") || null,
                frame: $("#wc-product-types .active-value").data("testid") || null,
                frameColor: $("#wc-frame-colors .active-value").data("testid") || null,
                borderWidth: $("#wc-border-width .active-value").text() || null,
                borderColor: $("#wc-border-colors .active-value").data("testid") || null,
                text: $("#wc-text").val(),
                font: $("#wc-fonts .active-value").data("testid") || null,
                image: parsed.url,        // uploaded image URL
                imageBase64: base64Data,  // store base64 locally for later use
                price: $("#wc-price").data("selectedPrice") || "99.99"
            };
    
            // Save locally
            savedProducts.push(config);
            localStorage.setItem("savedProducts", JSON.stringify(savedProducts));
    
            // Update UI
            renderSavedProducts();
            resetCustomizer();
    
            $("#savedProductsLoader").hide();
    
            return config;
    
        } catch (err) {
            $("#savedProductsLoader").hide();
            console.error("Error during Save:", err);
            alert("Something went wrong while saving. Try again!");
        }
    });
    //SAVE BUTTON function end



    // RENDER SAVED PRODUCTS

    function renderSavedProducts() {

        const container = $("#savedProducts");
        container.html("");

        if (savedProducts.length === 0) {
            container.html(`<p class="no-products-msg">No saved products available</p>`);
            return;
        }


        $("#savedProducts").html("");
        savedProducts.forEach((item, i) => {
            $("#savedProducts").append(`
                <div class="saved-item" data-index="${i}">
                    <div class="img-box">
                        <img src="${item.image}" style="width:100px;height:100px;object-fit:cover;">
                    </div>
                    <div class="content-box">
                        <p>${item.frame || ""} ${item.size || ""}</p>
                        <div class="price_dltWrap">
                            <p>${item.price}</p>
                            <div class="dltt_bttn" data-index="${i}"></div>
                        </div>
                    </div>
                </div>
            `);
        });

        // ✅ attach delete click
        $(".dltt_bttn").off("click").on("click", function () {
            const index = $(this).data("index");
            savedProducts.splice(index, 1); // remove from array
            localStorage.setItem("savedProducts", JSON.stringify(savedProducts)); // update storage
            renderSavedProducts(); // re-render UI
        });
    } 


    // RESET CUSTOMIZER
    function resetCustomizer() {
        $(".Tile").css({
            width: "360px",
            height: "360px",
            background: "transparent",
            border: "none",
        });
        $(".FramedTile").css({
            width: "100%",
            height: "100%",
            background: "transparent",
        });
        $(".preview-img").attr("src", "https://app.snappytack.com/asset/image-.png");
        $(".preview-img").removeClass("uploaded-cstm-img");
        $(".preview-img").addClass("default_vectorImg");
        $(".preview-img").css({
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%) scale(1) !important",
            height: "auto",
        });
        $(".tile-image").removeClass("actv");
        $(".view_wallBtn").removeClass("enable-button");
        $(".wc-sidebar").removeClass("image-uploaded-now");
        $(".wc-sidebar .wc-step").removeClass("active");
        // var minValue = $("#wc-zoom-range").attr("min");
        // $("#wc-zoom-range").val(minValue); 
        // $("#wc-zoom-label").text(minValue + "%");
        dragEnabled = false; // turn off drag
        $("#wc-text").val("");
        $(".text-container .border-text").text("");
        $(".FramedTile .text-container").addClass("reset_text-container");
        $(".FramedTile .text-container").removeClass("update_text-container");
        $(".filter-btn-wrp").addClass("hidden_filter");
        $(".wc-toolbar").removeClass("active_toolbar");
    }

    $(".saved_cart_click").on("click", function() {
         $(".saved_productList_wrap").addClass("open");
    });

    // delegated binding (works even for dynamically added buttons)
    $(document).on("click", ".saved_productList_wrap .close_popUp", function() {
        $(this).closest(".saved_productList_wrap").removeClass("open");
    });





   
var $sidebar = $(".wc-sidebar");

  // Open sidebar
  $(".fltr-cstm").on("click", function (e) {
    e.preventDefault();
    $sidebar.addClass("image-uploaded-now");
  });

  // Close sidebar only with close button
  $(".cros-cstm").on("click", function (e) {
    e.preventDefault();
    $sidebar.removeClass("image-uploaded-now");
  });


    // ------------------ Initialize ------------------
    loadOptions();
    initImageUpload();
    adjustImageFit();

    });